import React from 'react';
import MenuItem from '@mui/material/MenuItem';
import TextField from '@mui/material/TextField';
import PropTypes from 'prop-types';

const dropdownStyle = (width) => ({
  position: 'absolute',
  left: '0px',
  border: '2px solid #4e73df',
  borderRadius: '4px',
  marginTop: '4px',
  maxHeight: '200px',
  overflowY: 'auto',
  width,
  fontSize: '18px',
  backgroundColor: '#f8f9fa',
  zIndex: 1000,
});

const itemStyle = (highlighted) => ({
  cursor: 'pointer',
  padding: '8px',
  borderBottom: '1px solid #eee',
  fontSize: '18px',
  backgroundColor: highlighted ? '#4e73df' : 'transparent',
  color: highlighted ? 'white' : 'black',
});

const ShippingAutocompleteField = ({
  id,
  value,
  errorKey,
  placeholder,
  translate,
  autocomplete,
  onValueChange,
  getItemKey,
  renderItem,
  dropdownWidth = '180%',
  fullWidth = true,
  inputWidth,
  maxLength = 100,
}) => {
  const stopPropagation = (event) => event.stopPropagation();
  const handleChange = (event) => {
    const nextValue = event.target.value.toUpperCase();
    onValueChange(nextValue);
    autocomplete.debouncedSearch(nextValue);
  };
  const handleKeyDown = (event) => {
    stopPropagation(event);
    autocomplete.handleKeyDown(event);
  };

  return (
    <div className="shipping-autocomplete" style={{ position: 'relative' }}>
      <TextField
        id={id}
        name={id}
        autoComplete="off"
        value={value}
        onClick={stopPropagation}
        onFocus={stopPropagation}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
        onBlur={autocomplete.handleBlur}
        label={errorKey ? translate(errorKey) : placeholder}
        placeholder={placeholder}
        variant="standard"
        error={Boolean(errorKey)}
        fullWidth={fullWidth}
        inputProps={{
          style: { fontSize: '18px', ...(inputWidth ? { width: inputWidth } : {}) },
          maxLength,
        }}
        InputLabelProps={{ style: { fontSize: '18px' } }}
      />
      {autocomplete.filteredItems.length > 0 && (
        <div
          className="dropdown-class"
          style={dropdownStyle(dropdownWidth)}
          onClick={stopPropagation}
          onMouseDown={(event) => event.preventDefault()}
        >
          {autocomplete.filteredItems.map((item, index) => (
            <MenuItem
              key={getItemKey(item, index)}
              onMouseDown={(event) => event.preventDefault()}
              onClick={(event) => {
                stopPropagation(event);
                autocomplete.handleSelect(item);
              }}
              style={itemStyle(index === autocomplete.highlightedIndex)}
            >
              {renderItem(item)}
            </MenuItem>
          ))}
        </div>
      )}
    </div>
  );
};

ShippingAutocompleteField.propTypes = {
  id: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  errorKey: PropTypes.string,
  placeholder: PropTypes.string.isRequired,
  translate: PropTypes.func.isRequired,
  autocomplete: PropTypes.shape({
    filteredItems: PropTypes.array.isRequired,
    highlightedIndex: PropTypes.number.isRequired,
    debouncedSearch: PropTypes.func.isRequired,
    handleKeyDown: PropTypes.func.isRequired,
    handleBlur: PropTypes.func.isRequired,
    handleSelect: PropTypes.func.isRequired,
  }).isRequired,
  onValueChange: PropTypes.func.isRequired,
  getItemKey: PropTypes.func.isRequired,
  renderItem: PropTypes.func.isRequired,
  dropdownWidth: PropTypes.string,
  fullWidth: PropTypes.bool,
  inputWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  maxLength: PropTypes.number,
};

export default ShippingAutocompleteField;
